/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {DelBusinessProfileType} from "./del-business-profile-type.model";
import {JSONable} from "@irian-ro/abstract-resource";

export class DelBusinessProfileDto extends JSONable{
  uuid: string | undefined = undefined;
  ownerLeUuid: string | undefined = undefined;
  partnerLeUuid: string | undefined = undefined;
  businessProfileType: DelBusinessProfileType | undefined = undefined;
  isCustomer:boolean | undefined = undefined;
  isVendor: boolean | undefined = undefined;
  partnerInPlatform: boolean | undefined = undefined;
}
